//file inputs
const custom_file_inputs = document.querySelectorAll('.input-file-custom');

if (custom_file_inputs && custom_file_inputs.length > 0) {

  custom_file_inputs.forEach((custom_input) => {

    const input     = custom_input.querySelector('input[type="file"]');
    const file_name = custom_input.querySelector('.file-name')

    if (input.files.length > 0) {
      file_name.innerHTML = input.files[0].name
    }

    input.addEventListener('change', function() {
      file_name.innerHTML = this.files[0].name;
    });
  })
}


//action status
const action_status = document.querySelector('.admin-action-status');

if (action_status) {
  setTimeout(() => {
    action_status.classList.add('admin-action-status-hidden')
  }, 2000)
}


//menu mobile
const classesToAction = [document.querySelector('.hamburger'), document.querySelector('.admin-menu')];

if (classesToAction.length > 0 && window.innerWidth < 1081) {

  classesToAction[0].addEventListener('click', () => {
    classesToAction.forEach(item => item.classList.toggle('active'));
  })
}
